<script setup lang="ts"></script>

<template>
  <h2 class="mt-0.5 mb-2 px-2 py-1 bg-stone-300 text-black tracking-wide text-xs uppercase font-bold rounded">
    <slot />
  </h2>
</template>
